/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { SxProps, Theme } from '@mui/material';

export const footerContainerSX = (csrSession: boolean): SxProps<Theme> => ({
	alignSelf: 'stretch',
	justifySelf: 'flex-end',
	backgroundColor: 'transparent',
	boxShadow: 'none',
	img: {
		height: (theme) => theme.spacing(3),
	},
	...(!csrSession && { mt: 'auto' }),
});

export const footerCustomContainerSX = (theme: Theme, csrSession: boolean): SxProps<Theme> => ({
	alignSelf: 'stretch',
	justifySelf: 'flex-end',
	backgroundColor: 'transparent',
	boxShadow: 'none',
	img: {
		height: (theme) => theme.spacing(3),
	},
	...(!csrSession && { mt: 'auto' }),
	[theme.breakpoints.down('lg')]: {
		marginBottom: '60px',
	},
});

export const footerMuiContainerSX: SxProps<Theme> = {
	padding: '0 !important',
};

export const footerAppMobileContainerSX: SxProps<Theme> = {
	'@media (max-width:800px)': {
		pt: '90px',
	},
};
